import { render, staticRenderFns } from "./agravosForm.vue?vue&type=template&id=86ccc07c"
import script from "./agravosForm.vue?vue&type=script&lang=js"
export * from "./agravosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports